export const iconFontAwesomeTextformattingTableCellsLarge = (
	<i className="fa-solid fa-table-cells-large"></i>
);
